import Component from "../abstracts/Component";
import ModalMixinComponent from './mixins/ModalMixinComponent'

export default class SizeGuidePdpComponent extends Component {
  get COMPONENTNAME() {
    return 'SizeGuidePdpComponent';
  }
  get SELECTORS() {
    return {
      cta: '[data-size-guide-cta]',
      modal: '[data-size-guide-modal]',
    };
  }

  readDOM() {
    return {
      cta: this.$component.querySelector(this.SELECTORS.cta),
      modal: this.$component.querySelector(this.SELECTORS.modal),
    }
  }

  bindEvents() {
    this.dom.cta.addEventListener('click', () => {
      document.body.style.overflow = 'hidden';
      this.modal.show();
    });

    this.dom.modal.addEventListener(this.$customEvents.MODAL.hide, () => {
      document.body.style.overflow = null;
    })
  }

  render() {
    super.render();

    this.dom = this.readDOM();

    this.modal = new ModalMixinComponent(this.dom.modal);
    this.modal.render();

    this.bindEvents();
  }
}
